import { takeLatest, put, call, all } from 'redux-saga/effects';
import bowser from 'bowser';
import { isSupportedLanguage } from '../../shared/helpers/helpers';
import {
    loginService,
    getQuickSetupStateService,
    initSessionVariablesService,
    checkUsernameService,
    resetPasswordService,
    getLicenceStatusService,
    getUnauthorizedVPNStatusService,
    connectToSupportVPNServices
} from '../services/authService';
import { addCountries, addTimezones, addLanguages, enqueueSnackbar, setIsNano, setHasSetup } from '../../app/actions/appActions';
import {
    LOG_IN_REQUEST,
    LOG_OUT,
    CHECK_USERNAME_REQUEST,
    RESET_PASSWORD_REQUEST,
    GET_SUPPORT_CONNECTION_REQUEST,
    CONNECT_TO_SUPPORT_VPN_REQUEST
} from '../actions/authActionTypes';
import {
    loginSuccess,
    loginError,
    checkUsernameSuccess,
    checkUsernameFailure,
    resetPasswordSuccess,
    resetPasswordFailure,
    getSupportConnectionSuccess,
    getSupportConnectionFailure,
    connectToSupportVPNSuccess,
    connectToSupportVPNFailure
} from '../actions/authActions';
import { changeStep, updateStep } from '../../wizard/actions/wizardActions';
import {
    chooseNetworkingMethod,
    setLANData,
    setWANData,
    buildInitialTrunks
} from '../../wizard/helpers/wizardHelpers';

const logIn = function* (action) {
    try {
        const { username, password, history, location } = action.payload;

        const userAgentData = bowser.getParser(window.navigator.userAgent);
        const browserName = userAgentData.getBrowserName();
        const browserVersion = userAgentData.getBrowserVersion();
        const os = userAgentData.getOS().name;

        if (location.pathname === '/signin/admin' || location.pathname === '/setup') {
            const { data: { token, ttl, permissions } } = yield call(loginService, username, password, false);

            localStorage.setItem('token', token);
            localStorage.setItem('ttl', ttl);
            localStorage.setItem('permissions', permissions);
            localStorage.setItem('accessDate', Date.now());

            let {
                data: {
                    Countries,
                    TimesZones,
                    Languages,
                    Trunks,
                    Networking,
                    Nano,
                    SetupInfo: { Status }
                }
            } = yield call(getQuickSetupStateService, true);

            yield put(setIsNano(Nano));

            if (Nano) {
                yield put(loginSuccess(username, true, permissions));

                yield put(setHasSetup(Status === 1));

                switch (Status) {
                    case 0: {
                        console.log('SHOULD GO TO QUICK SETUP SINCE IT IS HAS NOT BEEN DONE');

                        yield put(addCountries(Countries));
                        yield put(addTimezones(TimesZones));
                        yield put(addLanguages(Languages));
                        yield put(changeStep(1));
                        yield put(updateStep({
                            Key: 'networking',
                            Optional: false,
                            Completed: false,
                            AbleToComplete: false,
                            InitialValid: true,
                            Method: chooseNetworkingMethod(Networking),
                            DNSServer: '8.8.8.8,4.2.2.2',
                            LAN: setLANData(Networking.LAN),
                            WAN: setWANData(Networking.WAN),
                            DHCP: {
                                DHCPServer: false,
                                IPFrom: '',
                                IPTo: '',
                                Netmask: '',
                                Gateway: '',
                                DNSServer: '',
                                TFTP: ''
                            }
                        }));
                        yield put(updateStep({
                            Key: 'users',
                            Optional: false,
                            Completed: true,
                            AbleToComplete: false,
                            InitialValid: true,
                            From: '100',
                            Qtty: '20',
                            Random: '1',
                            Password: '',
                            RepeatedPassword: ''
                        }));
                        yield put(updateStep({
                            Key: 'trunks',
                            Optional: false,
                            Completed: false,
                            AbleToComplete: false,
                            Trunks: buildInitialTrunks(Trunks)
                        }));

                        history.push('/setup');

                        break;
                    }
                    case 1: {
                        console.log('SHOULD GO TO DASHBOARD AS ADMIN SINCE QUICK SETUP HAS ALREADY BEEN DONE IN DENWA NANO');

                        yield put(addCountries(Countries));
                        yield put(addTimezones(TimesZones));
                        yield put(addLanguages(Languages));
                        yield put(changeStep(1));
                        yield put(updateStep({
                            Key: 'networking',
                            Optional: false,
                            Completed: false,
                            AbleToComplete: false,
                            InitialValid: true,
                            Method: chooseNetworkingMethod(Networking),
                            DNSServer: '8.8.8.8,4.2.2.2',
                            LAN: setLANData(Networking.LAN),
                            WAN: setWANData(Networking.WAN),
                            DHCP: {
                                DHCPServer: false,
                                IPFrom: '',
                                IPTo: '',
                                Netmask: '',
                                Gateway: '',
                                DNSServer: '',
                                TFTP: ''
                            }
                        }));
                        yield put(updateStep({
                            Key: 'users',
                            Optional: false,
                            Completed: true,
                            AbleToComplete: false,
                            InitialValid: true,
                            From: '100',
                            Qtty: '20',
                            Random: '1',
                            Password: '',
                            RepeatedPassword: ''
                        }));
                        yield put(updateStep({
                            Key: 'trunks',
                            Optional: false,
                            Completed: false,
                            AbleToComplete: false,
                            Trunks: buildInitialTrunks(Trunks)
                        }));

                        const { data: { result } } = yield call(
                            initSessionVariablesService,
                            username,
                            password,
                            true,
                            browserName,
                            browserVersion,
                            os
                        );

                        if (result === 0) {
                            yield put(loginSuccess(username, true, permissions));

                            history.push('/');
                        }

                        break;
                    }
                    case 2: {
                        console.log('GO TO QUICK SETUP DUE TO A MISTAKE');

                        yield put(changeStep(6));

                        history.push('/setup');

                        break;
                    }
                    case 3: {
                        console.log('QUICK SETUP IN PROGRESS');

                        yield put(changeStep(7));

                        history.push('/setup');

                        break;
                    }
                    default: break;
                }
            } else {
                console.log('SHOULD GO TO DASHBOARD AS ADMIN IN A NON NANO MODEL');

                yield put(addCountries(Countries));
                yield put(addTimezones(TimesZones));
                yield put(addLanguages(Languages));

                const { data: { result } } = yield call(
                    initSessionVariablesService,
                    username,
                    password,
                    true,
                    browserName,
                    browserVersion,
                    os
                );

                if (result === 0) {
                    yield put(loginSuccess(username, true, permissions));

                    history.push('/');
                } else {
                    throw new Error();
                }
            }
        } else {
            console.log('SHOULD GO TO DESKTOP AS NON ADMIN');

            const { data: { gotourl, result } } = yield call(
                initSessionVariablesService,
                username,
                password,
                false,
                browserName,
                browserVersion,
                os
            );

            if (result === 0) {
                window.location.href = `http://${window.location.hostname}/${gotourl}`;
            } else {
                throw new Error();
            }
        }
    } catch (error) {
        yield put(loginError());
        yield put(enqueueSnackbar({
            message: 'validations:INVALID_USER_PASSWORD',
            options: { variant: 'error' }
        }));
    }
};

const logOut = action => {
    const { isAdmin, history } = action.payload;
    const loginPage = isAdmin ? '/signin/admin' : '/signin';

    localStorage.removeItem('token');
    localStorage.removeItem('ttl');
    localStorage.removeItem('permissions');
    localStorage.removeItem('accessDate');

    history.push(loginPage);
};

const checkUsernameTask = function* (action) {
    try {
        const { username, history, location } = action.payload;
        const pathname = location.pathname.replace('check-username', '');
        const profile = pathname === '/signin/admin/' ? 'admin' : 'user';
        const { data: { email } } = yield call(checkUsernameService, username, profile, window.navigator.language);

        yield put(checkUsernameSuccess(username, email));
        yield put(enqueueSnackbar({
            message: 'auth:SECURITY_CODE_SENT',
            options: { variant: 'success' }
        }));

        history.push(`${pathname}reset-password-code`);
    } catch (error) {
        yield put(checkUsernameFailure());
        yield put(enqueueSnackbar({
            message: 'validations:ERROR',
            options: { variant: 'error' }
        }));
    }
};

const resetPasswordTask = function* (action) {
    try {
        const { username, securityCode, password, history, location } = action.payload;
        const pathname = location.pathname.replace('reset-password', '');
        const profile = pathname === '/signin/admin/' ? 'admin' : 'user';

        yield call(resetPasswordService, username, profile, window.navigator.language, securityCode, password);
        yield put(resetPasswordSuccess());
        yield put(enqueueSnackbar({
            message: 'auth:RESET_PASSWORD',
            options: { variant: 'success' }
        }));

        history.push(pathname.slice(0, -1));
    } catch (error) {
        yield put(resetPasswordFailure());
        yield put(enqueueSnackbar({
            message: 'validations:ERROR',
            options: { variant: 'error' }
        }));
    }
};

export const getSupportConnectionStatusTask = function* () {
    try {
        const [licenceStatus, vpnStatus] = yield all([
            call(getLicenceStatusService),
            call(getUnauthorizedVPNStatusService)
        ]);

        const { data: { info: { enabled, license } } } = licenceStatus;
        const { data: { conn: status, tun_address: ip } } = vpnStatus;

        yield put(getSupportConnectionSuccess(license, enabled, ip, status));
    } catch (error) {
        yield put(getSupportConnectionFailure());
    }
};

const connectToSupportVPNTask = function* () {
    try {
        const language = isSupportedLanguage(window.navigator.language) ? window.navigator.language : 'es';

        yield call(connectToSupportVPNServices, language);

        const { data: { conn: status, tun_address: ip } } = yield call(getUnauthorizedVPNStatusService);

        yield put(connectToSupportVPNSuccess(ip, status));
    } catch (error) {
        yield put(connectToSupportVPNFailure());
    }
};

export default function* authSaga() {
    yield takeLatest(LOG_IN_REQUEST, logIn);
    yield takeLatest(LOG_OUT, logOut);
    yield takeLatest(CHECK_USERNAME_REQUEST, checkUsernameTask);
    yield takeLatest(RESET_PASSWORD_REQUEST, resetPasswordTask);
    yield takeLatest(GET_SUPPORT_CONNECTION_REQUEST, getSupportConnectionStatusTask);
    yield takeLatest(CONNECT_TO_SUPPORT_VPN_REQUEST, connectToSupportVPNTask);
}
